export const showDockPaths = ['/', '/page/ordering', '/order', '/orders'];